import UserProfile from '@/entities/UserProfile';
import { db } from '@/vendors/firebase/firebase';

export default {
  async getUserProfile(userId) {
    const snap = await db.collectionGroup('users').where('id', '==', userId).get();
    const list = [];
    snap.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    if (list.length) {
      return new UserProfile(list[0]);
    }
    return null;
  },
  // TODO:
  // This kind of function has no sense.
  // We should consider removing users from shop entity.
  async getShopUserProfile(shopId, userId) {
    const doc = await db.collection('shops')
      .doc(shopId)
      .collection('users')
      .doc(userId)
      .get();
    return new UserProfile({ ...doc.data(), id: doc.id });
  },
};
